const UI_CONFIG = {
  overlayResolution: 700,
  size: { x: 2, y: 1.16 },
}

export { UI_CONFIG };
